import Auth from "../Auth.js";

/**
 * Static utility methods for sending annotation data to the backend
 */
class Annotation {
  /**
   * Set an annotation on the server
   * @param {string} documentId - The document ID
   * @param {number} from - The start position of the annotation (selection.from)
   * @param {number} to - The end position of the annotation (selection.to)
   * @param {string} annotationId - The annotation ID
   */
  static async set(documentId, from, to, annotationId) {
    const result = await Auth.fetchWithIdToken(`/api/annotations/new`, { documentId, from, to, annotationId });
    return result.annotation;
  }

  static async unset(documentId, annotationId) {
    const req = { documentId };
    await Auth.fetchWithIdToken(`/api/annotations/${annotationId}/delete`, req);
  }
}

export default Annotation;
